import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CollapsiblePanel } from 'app-components';
import Table from '../../common/table/Table';
import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';
import { DATE_FORMATS, formatToLocale } from '@utils/dates/dateMethods';

const SummaryOfReportedEvents = ({ applicants, latestApp, envData }) => {
    const lang = envData.language;
    const data = [];
    const columns = [
        {
            id: 'name',
            text: <FormattedMessage id='common.member_name'/>
        },
        {
            id: 'event',
            text: <FormattedMessage id='common.event'/>
        },
        {
            id: 'date',
            text: <FormattedMessage id='common.event_date'/>
        }
    ];

    applicants && applicants.forEach(applicant => {
        const { firstName, middleName, lastName, nameSuffix: suffix } = applicant;
        const memberName = normalizeNameOfPerson({ firstName, middleName, lastName, suffix });

        applicant && applicant.applicantEvents && applicant.applicantEvents.map(({ eventDate, eventLabelEN, eventLabelES }) => {
            data.push({
                name: memberName,
                event: lang === 'es' ? eventLabelES : eventLabelEN,
                date: formatToLocale(eventDate, envData.language, DATE_FORMATS.DATE_FORMAT2)
            });
        });
    });

    return (
        data.length > 0 &&
        <div className="applications-summary-events">
            <CollapsiblePanel isNoPanel={true} isInitialExpanded={latestApp} header={<FormattedMessage id='applications.summary_events'/>}>
                <Table data={data} columns={columns}/>
            </CollapsiblePanel>
        </div>

    );
};

export default SummaryOfReportedEvents;